// extracted by mini-css-extract-plugin
export default {"projects_div":"ProjectList_projects_div__aASJ9","project_div":"ProjectList_project_div__u+jvK","user_input_wrapper":"ProjectList_user_input_wrapper__0pMcG"};